import HttpService from "./htttp.service";

class NcrService {
  getEligibleAudits = async (query) => await HttpService.get("ncr/audits", query);
  getPeople = async (auditId) => await HttpService.get(`ncr/audits/${auditId}/people`);
  getSourceAudit = async (id) => await HttpService.get(`ncr/audits/${id}`);
  getNcrs = async (query, cancelToken) => {
    const endpoint = "ncr";
    return await HttpService.get(endpoint, query, cancelToken);
  };

  getNcrStatuses = async (query, cancelToken) => {
    const endpoint = "ncr/statuses";
    return await HttpService.get(endpoint, query, cancelToken);
  };

  getNcr = async (id, query, cancelToken) => {
    const endpoint = "ncr/" + id;
    return await HttpService.get(endpoint, query, cancelToken);
  };

  createNcr = async (payload) => {
    const endpoint = "ncr";
    const fileAttachments = [];

    const details = (payload.details || []).map((detail) => {
      const attachments = [];
      (detail.attachments || []).forEach((attachment) => {
        if (attachment.url && typeof attachment.url != "string") {
          const fileIndex = fileAttachments.length;
          fileAttachments.push(attachment.url);
          attachments.push({
            fileIndex,
            remarks: attachment.remarks,
            type: attachment.type,
          });
        } else {
          attachments.push(attachment);
        }
      });
      return { ...detail, attachments };
    });

    if (!fileAttachments.length)
      return await HttpService.post(endpoint, { ...payload, details });

    return await HttpService.uploadFilesWithData(
      endpoint,
      fileAttachments,
      { ...payload, details },
      "post",
    );
  };

  createManyNcrs = async (payload) => {
    const endpoint = "ncr/createmany";
    return await HttpService.post(endpoint, payload);
  };

  removeNcr = async (id) => await HttpService.delete(`ncr/${id}`);
  updateNcr = async (id, payload) => {
    const endpoint = "ncr/" + id;
    return await HttpService.put(endpoint, payload);
  };

  updateNcrDetail = async (ncrId, id, payload) => {
    const endpoint = `ncr/${ncrId}/details/${id}`;
    const fileAttachments = [];
    const attachments = [];

    (payload.attachments || []).forEach((attachment) => {
      if (attachment.url && typeof attachment.url != "string") {
        fileAttachments.push(attachment.url);
      } else {
        attachments.push(attachment);
      }
    });

    if (!fileAttachments.length) {
      return await HttpService.put(endpoint, {
        ...payload,
        ...(payload.attachments === undefined ? {} : { attachments }),
      });
    }

    return await HttpService.uploadFilesWithData(
      endpoint,
      fileAttachments,
      { ...payload, attachments },
      "put",
    );
  };

  generateNcrReportLink = async (id, query, payload) => {
    const endpoint = `ncr/${id}/report/link`;
    return await HttpService.post(endpoint, payload, query);
  };

  generateMultipleNcrReportLink = async (ids, query) => {
    return await HttpService.post("ncr/reports/link", { ids }, query);
  };
}

export default new NcrService();
